import React from 'react';

import { useParams } from 'react-router-dom';
import { AccessInformation } from '../components/AccessInformation/AccessInformation';
import { AccessPoint } from '../components/AccessPoint/AccessPoint';

export const AccessPointPage = () => {
    const { accesspointcode } = useParams();

    return (
        <AccessInformation enabled={!!accesspointcode}>
            {({ accessInformation, translations }) => {
                return <AccessPoint accessInformation={accessInformation} translations={translations} />;
            }}
        </AccessInformation>
    );
};
